import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['bootstrap']),
    validation() {
      return this.bootstrap.passwordValidationConfig || {};
    },
    /**
     * Mensaje para informar al usuario de los requisitos de la contraseña configurados en el proyecto.
     * Se construye a partir de la configuración de validación de contraseñas enviadas por API.
     * @return {string}
     */
    passwordValidationMessage() {
      const validationMessageParts = [];
      // Longitud mínima de la contraseña
      if ('min' in this.validation && this.validation.min > 0) {
        validationMessageParts.push(this.$t('message.login.changePassword.validationMessage.min', [this.validation.min]));
      }

      // Número de ocurrencias consecutivas de un mismo carácter permitido
      if ('max_same_consecutive_chars' in this.validation && this.validation.max_same_consecutive_chars > 0) {
        validationMessageParts.push(this.$t('message.login.changePassword.validationMessage.max_same_consecutive_chars', [this.validation.max_same_consecutive_chars]));
      }

      // Reglas que validan la ocurrencia de determinados caracteres en la contraseña
      const containsRules = Object.entries(this.validation)
        .filter(([rule, value]) => rule.startsWith('contains') && Boolean(value));
      if (containsRules.length > 0) {
        const containsRulesPrefix = this.$t('message.login.changePassword.validationMessage.mustContain');
        const containsRulesMessage = containsRules
          .map(([rule, value]) => this.$t(`message.login.changePassword.validationMessage.${rule}`, [value]));
        validationMessageParts.push(`${containsRulesPrefix} ${this.joinStrings(containsRulesMessage)}`);
      }

      if (validationMessageParts.length === 0) {
        return '';
      }

      const validationMessagePrefix = this.$t('message.login.changePassword.validationMessage.passwordMust');
      const validationMessage = this.joinStrings(validationMessageParts);
      return `${validationMessagePrefix} ${validationMessage}.`;
    },
  },
  methods: {
    /**
     * Une las cadenas de texto enviadas en el parámetro `strings`, haciendo que el último elemento se una con un "y".
     * @example
     *   joinStrings(['apples', 'bananas', 'cucumbers']) // 'apples, bananas and cucumbers'
     * @param {String[]} strings
     * @return {string}
     */
    joinStrings(strings) {
      if (strings.length < 2) {
        return strings.join('');
      }

      return [
        strings.slice(0, -1)
          .join(', '),
        this.$t('message.common.and'),
        strings[strings.length - 1]]
        .join(' ');
    },
  },
};
